import React, { FunctionComponent } from 'react';
import { Route as DomRoute, RouteProps } from 'react-router-dom';
import { RouteProvider } from './RouteProvider';
import queryString from 'query-string';

export const Route: FunctionComponent<RouteProps> = ({
  children,
  component,
  ...props
}) => {
  const Component = component as any;
  const query = queryString.parse(location.search);
  return (
    <DomRoute {...props}>
      {routeProps => (
        <RouteProvider {...{ ...routeProps, query }}>
          {children ? (
            (children as Function)(routeProps)
          ) : (
            <Component {...routeProps} />
          )}
        </RouteProvider>
      )}
    </DomRoute>
  );
};
